export class Controller {

    /** @ngInject */
    constructor(AccountsResource) {
        this.AccountsResource = AccountsResource;
    }

    $onInit() {
    }

    remove() {
        this.isSaving = true;
        this.AccountsResource
            .removeUserFromGroups(
                this.resolve.companyId,
                this.resolve.accountId,
                this.resolve.groupIds
            )
            .then(() => this.close())
            .finally(() => this.isSaving = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/groups-apps/remove-from-group/remove-account-from-group.controller.js